import IconImg from "@components/Icon/IconImg";
import { NotificationDefaultProps } from "@features/notifications/NotificationToasts/utils/types";

/**
 * Renders a  notification toast display text and icon (if applicable).
 */
export default function NotificationWithoutRedirection({
  text,
  icon,
}: NotificationDefaultProps): React.ReactElement {
  return (
    <div data-testid="notification-without-redirection-component">
      <p className="mb-0 items-center justify-center py-5 text-center font-poppins text-xs font-semibold">
        {text}
      </p>

      {icon ? (
        <IconImg
          icon={icon}
          imgAlt="mybt"
          iconSize={24}
          className="ml-2 cursor-pointer"
        />
      ) : null}
    </div>
  );
}
